import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';
import { useQuery } from 'react-query';

import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';

export default function useGetIntoFolders(path) {
  return useQuery(
    ['repository-folders-sub-folder', path],
    async () => {
      const response = await makeApiRequest.get(
        createQueryParamsForGetReq(apiEndPoints.REPOSITORY_Directory_API, {
          path: path,
        })
      );

      return response.data;
    },
    {
      enabled: !!path,
    }
  );
}
